import React from "react";

export default function DataListDateRange({
  from = "",
  to = "",
  onChange,
  onClear,
}) {
  return (
    <div className="data-list-date-filters">
      <label className="data-list-date-field">
        <span className="data-list-date-label">From</span>
        <input
          type="date"
          className="data-list-date-input"
          value={from}
          onChange={(event) => onChange({ from: event.target.value, to })}
        />
      </label>
      <label className="data-list-date-field">
        <span className="data-list-date-label">To</span>
        <input
          type="date"
          className="data-list-date-input"
          value={to}
          onChange={(event) => onChange({ from, to: event.target.value })}
        />
      </label>
      <button type="button" className="data-list-filter-btn" onClick={onClear}>
        Clear
      </button>
    </div>
  );
}
